import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { WidgetState } from './state/widget.state';
import { SharedModule } from '../shared/shared.module';
import { WidgetConfigResolver } from './widget-config-resolver';

@NgModule({
  imports: [
    NgxsModule.forFeature([
      WidgetState
    ]),
    CommonModule,
    SharedModule
  ],
  declarations: [],
  exports: [],
  providers: [
    WidgetConfigResolver
  ]
})
export class WidgetAuthModule { }
